import React from 'react';

import { Link } from 'react-router-dom';

import { ApiOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { TenantProductName, TenantUserPermission } from '@recurrency/core-api-schema/dist/common/enums';
import { Menu } from 'antd';

import { useGlobalApp } from 'hooks/useGlobalApp';

import { hasUserPermission, shouldShowProduct } from 'utils/roleAndTenant';
import { routes } from 'utils/routes';

export const UserProfileMenu = () => {
  const { logout, activeTenant, activeUser } = useGlobalApp();
  // a stored MCP write implies read, so this admits either MCP permission
  const showMcpSessions =
    shouldShowProduct(activeTenant, TenantProductName.Mcp) &&
    hasUserPermission(activeTenant, TenantUserPermission.ActionMcpRead);

  return (
    <>
      <Menu style={{ backgroundColor: '#FAFAFA', borderRight: 'none' }}>
        <Menu.Item key="logged-in-as" disabled style={{ cursor: 'default' }}>
          Logged in as {activeUser?.fullName || 'Unknown user'}
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="settings" icon={<SettingOutlined />}>
          <Link to={routes.account.accountEdit()}>Settings</Link>
        </Menu.Item>
        {showMcpSessions && (
          <Menu.Item key="mcp-sessions" icon={<ApiOutlined />}>
            <Link to={routes.account.mcpSessions()}>MCP Sessions</Link>
          </Menu.Item>
        )}
        <Menu.Divider />
        <Menu.Item danger key="logout" icon={<LogoutOutlined />} onClick={() => logout()}>
          <span>Log Out</span>
        </Menu.Item>
      </Menu>
    </>
  );
};
